module.exports = __webpack_public_path__ + "static/media/advantage4.f652cbf3.png";